import React, { FunctionComponent } from 'react'
import { ArrowRight, Calendar } from 'react-feather'
import { ITimeline } from 'types/Timeline'
import Button from './Button'
import Link from './Link'

interface ITimelineProps {
  timelines: ITimeline[]
}

const Timeline: FunctionComponent<ITimelineProps> = ({ timelines }): JSX.Element => {
  return (
    <ol className="relative border-l border-gray-300 dark:border-gray-600">
      {timelines.map((timeline) => (
        <li className="mb-10 ml-8" key={timeline.title}>
          <span className="flex absolute -left-4 justify-center items-center w-8 h-8 bg-primary-200 rounded-full ring-8 ring-white dark:ring-gray-800 dark:bg-primary-600">
            {timeline.image ? timeline.image : <Calendar size={18} />}
          </span>
          <span className="flex flex-col md:flex-row items-start md:items-center justify-between mb-1 gap-2">
            <h3 className="text-lg lg:text-xl font-semibold text-gray-900 dark:text-white">
              {timeline.title}
            </h3>
            <span className="flex flex-row flex-wrap gap-4">{timeline.tags}</span>
          </span>
          <p className="block my-3 text-sm font-normal leading-none text-gray-400 dark:text-gray-500">
            {timeline.subtitle}
          </p>
          <div className="mb-4 text-base font-normal text-gray-500 dark:text-gray-300 max-w-4xl leading-7 space-y-4">
            {timeline.content}
          </div>
          {timeline.learnMore && (
            <Link href={timeline.learnMore} showExternalIcon={false} showExternalPreview={false}>
              <Button variant="outline">
                Learn more <ArrowRight className="ml-2 mt-0.5" size={16} />
              </Button>
            </Link>
          )}
        </li>
      ))}
    </ol>
  )
}

export default Timeline
